import { Component } from 'react'
import PinInput from "react-pin-input";
import { Button } from 'antd';
import { Timer } from '@operations/shared';
import { connect } from 'react-redux';
import {
    isAuthintecated,
    getAccessRoutes,
    changePhoneNumberStatus,
    changePinCodeStatus,
    changeForgotPasswordStatus,
    addPinCode,
    stepperMoving,
    setAuthErrorMsg,
    addPassword,
    setIsHR
} from "../stores/actions";
import { postApi, request } from '../apis';
import Cookies from 'js-cookie';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Region } from '../../../shared/src/utils/commonInterfaces';
import { getRegion } from './regionWrapper';

interface PROPS extends RouteComponentProps<any> {
    setAuthErrorMsg: any,
    isAuthintecated: any,
    changePhoneNumberStatus: any,
    getAccessRoutes: any,
    changePinCodeStatus: any,
    changeForgotPasswordStatus: any,
    postApi: any,
    addPinCode: any,
    time_out: boolean,
    phoneNumber: string,
    externalPhone?: string | null,
    submitFunc?: any,
    twilio?: boolean,
    userLang?: ("ar" | "en"),
    create?: boolean,
    stepperMoving?: any,
    phone: string,
    confirmUpdateData?: any,
    getOtpValue?: any,
    otpLoad?: boolean,
    otpModalVisible?: boolean,
    login?: boolean,
    addPassword: any,
    password: string,
    resetPassword?: boolean,
    request: any,
    setIsHR?: (value: boolean) => void
}
class SubmittingBin extends Component<PROPS> {
    region: Region = getRegion() ?? Region.EG;
    state = {
        btnLoader: false,
        successNotification: true,
        value: '',
        time: 60,
        errorMessage: null,
    }
    componentDidUpdate(prevProps: any) {
        if (this.props.time_out !== prevProps.time_out) {
            this.onPinClear();
            this.setState({ errorMessage: null })
        };
    }
    pinOnChange = (value: any) => {
        this.setState({ value, errorMessage: null });
    };
    pinOnCompleteLogin = async (value: string) => {
        if (this.props.time_out) {
            this.onPinClear()
            return 0
        }
        if (this.props.getOtpValue) {
            this.props.getOtpValue(value);
            return
        }

        if (this.props.login) {
            const info = {
                phone: this.props.phone,
                password: this.props.password,
                code: value,
            };
            this.responseHandling(false, true);
            const submitLogin = await this.props.postApi(`auth/login`, info);
            try {
                const { payload } = submitLogin;
                if (!payload || (payload.status !== 200 && payload.status !== 201)) {
                    this.responseHandling(false, false);
                    this.props.setAuthErrorMsg(payload?.message ?? 'Something went wrong. Please try again.')
                    this.props.changePhoneNumberStatus(false);
                    this.props.changePinCodeStatus(false);
                    this.props.addPassword(null);
                    this.props.addPinCode('');
                }
                else if (payload.status === 200 || payload.status === 201) {
                    this.responseHandling(true, false);
                    if (this.region === Region.EG) {
                        console.log(submitLogin.payload.accessRoutes);
                        let date = new Date();
                        date.setTime(date.getTime() + (24 * 60 * 60 * 1000));
                        Cookies.set('token', submitLogin.payload.token, { expires: date });
                    }
                    setTimeout(() => {
                        if (this.region === Region.EG) {
                            const rawIsHR = submitLogin?.payload?.isHR ?? submitLogin?.payload?.isHr;
                            const parsedIsHR = ['true', '1'].includes(
                                String(rawIsHR).trim().toLowerCase()
                            );
                            this.props.setIsHR?.(parsedIsHR);
                        }
                        this.props.isAuthintecated(true);
                        this.props.getAccessRoutes(payload.accessRoutes)
                        this.props.history.push(`/${payload.accessRoutes[0].path}`)
                        this.props.changePhoneNumberStatus(false);
                        this.props.changePinCodeStatus(false);
                        this.props.addPassword(null);
                        this.props.addPinCode('');
                    }, 100);
                } else {
                    this.responseHandling(true, false)
                    this.setState({ errorMessage: payload.message })
                    console.log(this.state.errorMessage);

                }
                console.log(submitLogin);

            } catch (error) {
                this.responseHandling(false, false)
            }
        } else if (this.props.resetPassword) {
            const info = {
                phone: this.props.phone,
                password: this.props.password,
                code: value,
            };
            try {
                this.responseHandling(false, true)
                const submitPassword = await this.props.request({
                    url: `/auth/change-password`,
                    method: "put",
                    data: info,
                });
                if (submitPassword.data.status === 200 || submitPassword.data.status === 201) {
                    this.responseHandling(true, false);
                    this.props.setAuthErrorMsg(submitPassword.data.message);
                    this.goLogin();
                }
                else {
                    this.responseHandling(false, false);
                    this.props.setAuthErrorMsg(submitPassword.data.message)
                    this.props.addPassword(null);
                    this.props.addPinCode('');
                    this.goResetPassword()
                }
            } catch (error: any) {
                console.log(
                    "🚀 ~ file: submitNewPassword.tsx ~ line 69 ~ SubmittingNewPassword ~ onFinish= ~ error",
                    error
                );
                this.responseHandling(false, false);
            }
        }
        else {
            let info = {
                phone: this.props.externalPhone ? this.props.externalPhone : this.props.phoneNumber ? this.props.phoneNumber : this.props.phone,
                code: value
            }

            this.responseHandling(true, true)
            const verifyOtp = await this.props.postApi(`auth/verify-otp`, info);
            try {
                if (verifyOtp.error) {
                    this.onPinClear()
                    this.responseHandling(false, false)
                    return 0;
                }
                if (verifyOtp.payload.status === 200) {
                    (this.props.phoneNumber && this.props.create) && this.props.stepperMoving(2)
                    if (this.props.submitFunc) {
                        this.props.submitFunc()
                        return
                    }
                    this.props.changePinCodeStatus(true)
                    this.responseHandling(true, false)
                    this.props.addPinCode(value)
                } else {
                    this.setState({ errorMessage: verifyOtp.payload.message })
                    this.onPinClear()
                    this.responseHandling(true, false)
                }

            } catch (error) {
                this.onPinClear()
                this.responseHandling(false, false)
            }
        }
    }
    goLogin = () => {
        this.props.changePhoneNumberStatus(false);
        this.props.changePinCodeStatus(false);
        this.props.changeForgotPasswordStatus(false);
    };
    goResetPassword = () => {
        this.props.changePhoneNumberStatus(false);
        this.props.changePinCodeStatus(false);
        this.onPinClear();
    };
    responseHandling = (successNotification: any, btnLoader: boolean) => {
        this.setState({ successNotification: successNotification, btnLoader: btnLoader })
    }
    onPinClear = () => {
        this.setState({
            value: ""
        });
        this.pinCode.clear();
    };
    pinCode: any;
    render() {
        let { btnLoader, time, errorMessage } = this.state;
        let { time_out, phoneNumber, externalPhone, twilio, userLang, phone } = this.props;
        return (
            <div>
                <PinInput length={5} focus
                    onChange={this.pinOnChange}
                    ref={pin => (this.pinCode = pin)}
                    type="numeric"
                    inputMode="number"
                    style={{ padding: '0', borderRadius: '8px' }}
                    inputStyle={time_out ? { borderColor: '#ff000e' } : { borderColor: '#d9d9d9' }}
                    inputFocusStyle={{ borderColor: '#7CC58F' }}
                    onComplete={this.pinOnCompleteLogin}
                    autoSelect={true}
                    regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                />
                {time_out && <p className='timeOut'>Time out your pin code not valid anymore</p>}
                {errorMessage && <p className='timeOut'>{errorMessage}</p>}

                {<Timer time={time} phone={externalPhone ? externalPhone : phoneNumber ? phoneNumber : phone} twilio={twilio} userLang={userLang} setLoading={(val: boolean) => this.setState({ btnLoader: val })} />}
                <Button className='bin' type="primary" htmlType="submit" loading={this.props.otpLoad ? this.props.otpLoad : btnLoader} block>
                    Submit
                </Button>
            </div >
        )
    }
}
const mapStateToProp = (state: any) => ({
    time_out: state.auth.time_out,
    phoneNumber: state.actionsReducer.info.phone,
    phone: state.auth.phoneNumber,
    password: state.auth.password,
    otpModalVisible: state.actionsReducer.otpModalVisible
})
export default withRouter(connect(mapStateToProp, {
    isAuthintecated,
    getAccessRoutes,
    changePhoneNumberStatus,
    changePinCodeStatus,
    changeForgotPasswordStatus,
    postApi,
    addPinCode,
    stepperMoving,
    setAuthErrorMsg,
    addPassword,
    request,
    setIsHR
})(SubmittingBin))